export function upperCaseInput(el)
{
  let p=el.selectionStart;
  el.value = el.value.toUpperCase();
  el.setSelectionRange(p,p);
}